"use strict";
exports.__esModule = true;
exports.Classification = void 0;
var Classification;
(function (Classification) {
    Classification["Events"] = "event";
    Classification["Publication"] = "publication";
    Classification["News"] = "news";
    Classification["Innovation"] = "innovations";
    Classification["Startup"] = "startup";
    Classification["InnerPage"] = "inner-page";
})(Classification = exports.Classification || (exports.Classification = {}));
//# sourceMappingURL=classification.js.map